<template>
    <!-- 桌面端布局 -->
    <div class="desktop-layout" v-if="!isMobile">
        <el-container style="height: 100vh;">
            <el-aside :width="isCollapse ? '80px' : '220px'" style="transition: width 0.3s;height: 100vh;display: flex;flex-direction: column;">
                <!-- 顶部logo区域：显示登录用户所属公司 logo -->
                <div class="logo-area" style="height: 40px; display: flex; align-items: center; justify-content: center; background-color: #304156; overflow: hidden; padding: 0 6px;">
                    <img v-if="companyLogo" :src="companyLogo" class="logo-img" :class="{ 'is-collapsed': isCollapse }" alt="logo">
                    <div v-else style="color: #fff; font-weight: bold; font-size: 16px;">{{ isCollapse ? 'L' : 'Logo' }}</div>
                </div>
                <el-menu :default-active="activeMenu"
                         :unique-opened="true"
                         class="el-menu-vertical"
                         background-color="#304156"
                         text-color="#bfcbd9"
                         active-text-color="#409EFF"
                         :collapse="isCollapse"
                         @select="handleMenuSelect">
                    <!-- DASHBOARD -->
                    <el-menu-item index="0-0" popper-class="menu-popover">
                        <el-icon><PieChart /></el-icon>
                        <template #title>
                            <span v-if="!isCollapse">仪表盘</span>
                        </template>
                    </el-menu-item>
                    <!-- CRM -->
                    <el-sub-menu index="1" popper-class="menu-popover">
                        <template #title>
                            <el-icon><User /></el-icon>
                            <span>CRM</span>
                        </template>
                        <el-menu-item index="1-1">
                            <el-icon><UserFilled /></el-icon>
                            <span>客户管理</span>
                        </el-menu-item>
                        <el-menu-item index="1-2">
                            <el-icon><Tickets /></el-icon>
                            <span>商机管理</span>
                        </el-menu-item>
                        <el-menu-item index="1-3">
                            <el-icon><ChatDotRound /></el-icon>
                            <span>跟进记录</span>
                        </el-menu-item>
                        <el-menu-item index="1-4">
                            <el-icon><Document /></el-icon>
                            <span>单证管理</span>
                        </el-menu-item>
                        <el-menu-item index="1-5">
                            <el-icon><Message /></el-icon>
                            <span>已发邮件</span>
                        </el-menu-item>
                    </el-sub-menu>

                    <!-- 订单管理 -->
                    <el-menu-item index="2" popper-class="menu-popover">
                        <el-icon><Tickets /></el-icon>
                        <template #title>
                            <span>订单管理</span>
                        </template>
                    </el-menu-item>

                    <!-- 产品管理 -->
                    <el-sub-menu index="3" popper-class="menu-popover">
                        <template #title>
                            <el-icon><Goods /></el-icon>
                            <span>产品管理</span>
                        </template>
                        <el-menu-item index="3-1">
                            <el-icon><Folder /></el-icon>
                            <span>产品类别</span>
                        </el-menu-item>
                        <el-menu-item index="3-2">
                            <el-icon><GoodsFilled /></el-icon>
                            <span>产品信息</span>
                        </el-menu-item>
                    </el-sub-menu>
                </el-menu>

                <!-- 底部用户信息区域 -->
                <div class="aside-bottom" :class="{ 'is-collapsed': isCollapse }" style="background-color: #304156; border-top: 1px solid #2d3a4b;">
                    <el-dropdown placement="top-start">
                        <div class="user-dropdown">
                            <el-avatar :size="28" style="background-color: #409EFF; color: #fff; flex-shrink: 0;">{{ username?.charAt(0).toUpperCase() }}</el-avatar>
                            <span class="username" v-if="!isCollapse">{{ username }}</span>
                        </div>
                        <template #dropdown>
                            <el-dropdown-menu>
                                <el-dropdown-item @click="handleProfile">
                                    <el-icon><User /></el-icon>
                                    设置
                                </el-dropdown-item>
                                <el-dropdown-item divided @click="handleLogout">
                                    <el-icon><SwitchButton /></el-icon>
                                    退出登录
                                </el-dropdown-item>
                            </el-dropdown-menu>
                        </template>
                    </el-dropdown>
                </div>
            </el-aside>

            <el-container>
                <el-header style="border-bottom: 1px solid var(--el-border-color-light); display: flex; align-items: center; justify-content: space-between; height: 60px; padding: 0 10px;">
                    <div style="display: flex; align-items: center;">
                        <!-- 缩放按钮移动到header左侧 -->
                        <div class="collapse-button" @click="toggleCollapse" style="margin-right: 10px;">
                            <el-icon>
                                <component :is="isCollapse ? 'Expand' : 'Fold'" />
                            </el-icon>
                        </div>
                        <!-- 时间线组件 -->
                        <WorldTimeLine style="margin-left: 20px;width:80VW" />
                    </div>
                </el-header>

                <el-main>
                    <router-view></router-view>
                </el-main>
            </el-container>
        </el-container>
    </div>

    <!-- 移动端布局 -->
    <div class="mobile-layout" v-else>
        <div class="mobile-header">
            <div class="header-title">
                {{ currentRouteName }}
            </div>
            <div class="header-user" @click="handleProfile">
                <el-avatar :size="32" style="background-color: #409EFF; color: #fff;">{{ username?.charAt(0).toUpperCase() }}</el-avatar>
            </div>
        </div>

        <div class="mobile-content">
            <router-view></router-view>
        </div>

        <div class="mobile-tabbar">
            <div class="tabbar-item"
                 v-for="item in mobileMenu"
                 :key="item.index"
                 :class="{ 'active': activeMenu === item.index }"
                 @click="handleMobileMenuSelect(item)">
                <el-icon>
                    <component :is="item.icon" />
                </el-icon>
                <span>{{ item.title }}</span>
            </div>
        </div>
    </div>
</template>

<script setup>
    import { ref, computed, onMounted, onUnmounted } from 'vue'
    import { useRouter, useRoute } from 'vue-router'
    import WorldTimeLine from '@/pages/timeline.vue'
    import { post } from '@/api/index'
    import { resolveImageUrl } from '@/utils/imageUrl'
    import logoPng from '@/assets/logo.png'
    import {
        User, Files, Goods, UserFilled, ChatDotRound, Tickets, Document,
        PriceTag, Ticket, Folder, GoodsFilled, SwitchButton, PieChart,
        Expand, Fold, Message
    } from '@element-plus/icons-vue'


    const router = useRouter()
    const route = useRoute()
    const username = ref(localStorage.getItem("username") || "用户")

    // 公司 logo：默认本地占位，登录后按所属公司替换
    const companyLogo = ref(logoPng)

    async function fetchCompanyLogo() {
        try {
            const res = await post('/apiserve/crmapi/system.asp', { action: 'my_companies' })
            const list = (res && (res.companies || res.data)) || []
            const pick = list.find(c => Number(c.is_default) === 1) || list.find(c => c.default) || list[0]
            if (pick && pick.companylogopath) {
                companyLogo.value = resolveImageUrl(pick.companylogopath)
            }
        } catch (e) {
            console.error('fetchCompanyLogo failed', e)
        }
    }

    // 设备检测逻辑
    const isMobile = ref(false)

    const checkIsMobile = () => {
        isMobile.value = window.innerWidth < 768
    }

    onMounted(() => {
        checkIsMobile()
        window.addEventListener('resize', checkIsMobile)
        fetchCompanyLogo()
    })

    onUnmounted(() => {
        window.removeEventListener('resize', checkIsMobile)
    })


    // 移动端菜单配置
    const mobileMenu = ref([
        { index: '0-0', title: '仪表盘', icon: PieChart, route: '/dashboard' },
        { index: '1-1', title: '客户', icon: UserFilled, route: '/customers' },
        { index: '1-2', title: '商机', icon: UserFilled, route: '/opportunities' },
        { index: '1-3', title: '跟进', icon: ChatDotRound, route: '/tracks' },
        { index: '1-4', title: '单证', icon: Document, route: '/documents' },
        { index: '2', title: '订单', icon: Tickets, route: '/orders' },
        { index: '3-2', title: '产品', icon: GoodsFilled, route: '/products' },
        { index: 'settings', title: '我的', icon: User, route: '/settings' }
    ])
    const currentRouteName = computed(() => {
        const matchedRoute = mobileMenu.value.find(item => item.route === route.path)
        return matchedRoute ? matchedRoute.title : '工作台'
    })

    // 活动菜单计算
    const activeMenu = computed(() => {
        const path = route.path
        if (path.startsWith('/dashboard')) return '0-0'
        if (path.startsWith('/customers')) return '1-1'
        if (path.startsWith('/opportunities')) return '1-2'
        if (path.startsWith('/tracks')) return '1-3'
        if (path.startsWith('/documents')) return '1-4'
        if (path.startsWith('/emaillog')) return '1-5'
        if (path.startsWith('/orders')) return '2'
        if (path.startsWith('/product-categories')) return '3-1'
        if (path.startsWith('/products')) return '3-2'
        if (path.startsWith('/settings')) return 'settings'
        return '0-0'
    })

    // 侧边栏折叠状态
    const isCollapse = ref(false)
    const toggleCollapse = () => {
        isCollapse.value = !isCollapse.value
    }

    // 路由映射
    const routesMap = {
        '0-0': "/dashboard",
        '1-1': '/customers',
        '1-2': '/opportunities',
        '1-3': '/tracks',
        '1-4': '/documents',
        '1-5': '/emaillog',
        '2': '/orders',
        '3-1': '/product-categories',
        '3-2': '/products',
        'settings': '/settings'
    }

    function handleMenuSelect(index) {
        const routePath = routesMap[index]
        if (routePath && route.path !== routePath) {
            router.push(routePath)
        }
    }

    function handleMobileMenuSelect(item) {
        if (route.path !== item.route) {
            router.push(item.route)
        }
    }

    function handleProfile() {
        router.push('/settings')
    }

    async function handleLogout() {
        try {
            // 调用后端清除 session
            await fetch('/apiserve/crmapi/logincheck.asp?action=logout', {
                method: 'POST'
            })
        } catch (e) {
            console.error('Logout API failed', e)
        }
        // 清除本地存储
        localStorage.clear()
        router.push('/login')
    }
</script>

<style scoped>
    /* 公共样式 */
    .el-container {
        background-color: #f5f7fa;
    }

    /* 桌面端样式 */
    .logo-area {
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: #304156;
    }

    .logo-img {
        max-height: 32px;
        max-width: 180px;
        object-fit: contain;
        display: block;
    }

    .logo-img.is-collapsed {
        max-width: 68px;
    }

    /* 底部用户区：展开/收起均居中，保持与菜单项对齐 */
    .aside-bottom {
        margin-top: auto;
        padding: 10px;
    }

    .aside-bottom.is-collapsed {
        padding: 5px 0;
    }

    .aside-bottom.is-collapsed .user-dropdown {
        justify-content: center;
    }

    .collapse-button {
        height: 40px;
        width: 40px;
        line-height: 40px;
        text-align: center;
        cursor: pointer;
        transition: all 0.3s;
        border-radius: 4px;
    }

        .collapse-button:hover {
            background-color: #f5f5f5;
        }

    .el-menu-vertical {
        border-right: none;
        flex: 1;
    }

    .user-dropdown {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        cursor: pointer;
        color: #bfcbd9;
        padding: 5px 10px;
        border-radius: 4px;
    }

        .user-dropdown:hover {
            background-color: #263445;
        }

    .username {
        margin-left: 10px;
    }

    /* 移动端样式 */
    .mobile-layout {
        display: flex;
        flex-direction: column;
        height: 100vh;
    }

    .mobile-header {
        height: 50px;
        background-color: #304156;
        color: white;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 15px;
        box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    }

    .header-title {
        font-size: 18px;
        font-weight: bold;
    }

    .header-user {
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .mobile-content {
        flex: 1;
        overflow-y: auto;
        padding: 15px;
        background-color: #f5f7fa;
    }

    .mobile-tabbar {
        height: 60px;
        display: flex;
        background-color: white;
        box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
    }

    .tabbar-item {
        flex: 1;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        color: #666;
        font-size: 12px;
        cursor: pointer;
    }

        .tabbar-item.active {
            color: #409EFF;
        }

        .tabbar-item .el-icon {
            font-size: 20px;
            margin-bottom: 4px;
        }

    /* 响应式隐藏 */
    @media (max-width: 768px) {
        .desktop-layout {
            display: none;
        }
    }

    @media (min-width: 769px) {
        .mobile-layout {
            display: none;
        }
    }
</style>
